var styles = {"icons":"styles_icons__WWKk-","wrap":"styles_wrap__JjrVL","allowShrink":"styles_allow-shrink__iwXW6","noSpacing":"styles_no-spacing__RueeK","compactSpacing":"styles_compact-spacing__o1H8C","comfortableSpacing":"styles_comfortable-spacing__APz9v","looseSpacing":"styles_loose-spacing__mygHk"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
